module.exports = __webpack_public_path__ + "img/1484534762.8333ed9b.jpg";